const defaultState = {};

export default function searchReducer(state = defaultState, action) {
  switch (action.type) {
    case 'SEARCH_INITIATED': {
      return {
        loading: true,
      };
    }
    case 'RECEIVE_SEARCH_RESULTS': {
      return {
        ...state,
        loading: false,
        results: action.hits,
        facets: action.facets,
      };
    }
    default:
      return state;
  }
}
